import { lazy } from 'react';
import Loadable from 'components/Loadable';
import { useRoutes, Navigate } from 'react-router-dom';

// Layouts
import MinimalLayout from 'layout/MinimalLayout';
import MainLayout from 'layout/MainLayout';

// Protected routes
import ProtectedRoute, { AdminRoute, isAdmin } from './ProtectedRoute';

// Lazy load pages
const Login = Loadable(lazy(() => import('pages/authentication/Login')));
const Register = Loadable(lazy(() => import('pages/authentication/Register')));
const ForgotPassword = Loadable(lazy(() => import('pages/authentication/ForgotPassword')));
const ResetPassword = Loadable(lazy(() => import('pages/authentication/ResetPassword')));
const Projet = Loadable(lazy(() => import('pages/projet/Projet')));
const ProjetById = Loadable(lazy(() => import('pages/projet/ProjetById')));
const StepperPage = Loadable(lazy(() => import('pages/stepper/StepperPage')));
const Placer = Loadable(lazy(() => import('pages/placer/Placer')));
const AdminDashboard = Loadable(lazy(() => import('pages/admin/AdminDashboard')));
const UserProfile = Loadable(lazy(() => import('pages/profile/UserProfile')));
const CuttingPage = Loadable(lazy(() => import('pages/cutting/CuttingPage')));

// Redirect component based on user role
function RoleBasedRedirect() {
  const token = localStorage.getItem('token');
  
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  
  // Check if admin - redirect to admin dashboard
  if (isAdmin(token)) {
    return <Navigate to="/admin" replace />;
  }
  
  // Regular users go to projet
  return <Navigate to="/projet" replace />;
}

// Main Router
export default function ThemeRoutes() {
  return useRoutes([
    // Public routes (no auth required)
    {
      path: '/',
      element: <MinimalLayout />,
      children: [
        { index: true, element: <RoleBasedRedirect /> },
        { path: 'login', element: <Login /> },
        { path: 'register', element: <Register /> },
        { path: 'forgot-password', element: <ForgotPassword /> },
        { path: 'reset-password', element: <ResetPassword /> },
      ]
    },
    
    // Protected routes (auth required)
    {
      path: '/',
      element: (
        <ProtectedRoute>
          <MainLayout />
        </ProtectedRoute>
      ),
      children: [
        // User routes
        {
          path: 'projet',
          element: <Projet />
        },
        {
          path: 'projet/:id',
          element: <ProjetById />
        },
        {
          path: 'stepper',
          element: <StepperPage />
        },
        {
          path: 'placer',
          element: <Placer />
        },
        {
          path: 'cutting',
          element: <CuttingPage />
        },
        {
          path: 'profile',
          element: <UserProfile />
        },
        
        // Admin routes (admin or super_admin only)
        {
          path: 'admin',
          element: (
            <AdminRoute>
              <AdminDashboard />
            </AdminRoute>
          )
        },
      ]
    },
    
    // Catch all - redirect to home
    {
      path: '*',
      element: <Navigate to="/" replace />
    }
  ]);
}
